import { render, staticRenderFns } from "./AccountAddressSettings.vue?vue&type=template&id=49a97b9a&"
import script from "./AccountAddressSettings.vue?vue&type=script&lang=js&"
export * from "./AccountAddressSettings.vue?vue&type=script&lang=js&"
import style0 from "./AccountAddressSettings.vue?vue&type=style&index=0&id=49a97b9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports